module.exports = __webpack_public_path__ + "static/media/outer_fabric.3bc2dade.svg";